<script lang="ts">
  import { app } from './store.svelte';
  import PrinterPanel from './PrinterPanel.svelte';
  import SettingsPanel from './SettingsPanel.svelte';
  import Icon from './lib/Icon.svelte';

  interface Props {
    onOpenInsert: () => void;
  }
  const { onOpenInsert }: Props = $props();
</script>

<aside class="left">
  <section class="grp">
    <h3><Icon name="plus" size={12} /> Ekle</h3>
    <div class="ins-grid">
      <button class="ins-card mesh" onclick={onOpenInsert}>
        <span class="card-icon"><Icon name="box" size={22} /></span>
        <span class="ins-name">Mesh</span>
        <span class="card-glow" aria-hidden="true"></span>
      </button>
      <button class="ins-card vase" onclick={() => { app.showVasePanel = true; }}>
        <span class="card-icon"><Icon name="aperture" size={22} /></span>
        <span class="ins-name">Vazo</span>
        <span class="card-glow" aria-hidden="true"></span>
      </button>
    </div>
  </section>
  <PrinterPanel />
  <SettingsPanel />
  {#if app.errorMessage}
    <p class="error">
      <Icon name="alert-circle" size={14} />
      <span>{app.errorMessage}</span>
    </p>
  {/if}
</aside>

<style>
  aside {
    overflow-y: auto; display: flex; flex-direction: column; gap: 14px;
    background:
      radial-gradient(140% 60% at 0% 0%, rgba(74, 184, 255, 0.04), transparent 60%),
      linear-gradient(180deg, var(--panel-overlay), transparent);
    border: 1px solid var(--border-soft);
    border-radius: var(--radius-card);
    padding: 14px;
  }
  .grp { display: flex; flex-direction: column; }
  h3 {
    margin: 0; font-size: 10px; font-weight: 600;
    color: var(--text-3); text-transform: uppercase; letter-spacing: 0.1em;
    display: inline-flex; align-items: center; gap: 6px;
  }
  .ins-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-top: 8px; }

  .ins-card {
    position: relative;
    display: flex; flex-direction: column; align-items: center; gap: 8px;
    padding: 16px 8px 14px;
    background: linear-gradient(180deg, rgba(255,255,255,0.04), rgba(255,255,255,0.01));
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 12px;
    cursor: pointer; color: var(--text-2);
    font-family: inherit;
    overflow: hidden;
    transition: transform 0.15s ease, border-color 0.18s ease, background 0.18s ease, box-shadow 0.18s ease;
  }
  .ins-card:hover {
    transform: translateY(-1px);
    border-color: rgba(74, 184, 255, 0.35);
    background: linear-gradient(180deg, rgba(74,184,255,0.08), rgba(255,255,255,0.02));
    box-shadow: 0 12px 28px -12px rgba(74, 184, 255, 0.55);
    color: var(--text-bright);
  }
  .ins-card:active { transform: translateY(0) scale(0.98); }

  .card-icon {
    width: 40px; height: 40px;
    display: inline-flex; align-items: center; justify-content: center;
    border-radius: 10px;
    background: linear-gradient(135deg, rgba(26,122,201,0.25), rgba(26,122,201,0.05));
    border: 1px solid rgba(74,184,255,0.25);
    color: #4ab8ff;
    transition: transform 0.18s ease;
  }
  .ins-card:hover .card-icon { transform: scale(1.06); }
  .ins-card.vase .card-icon {
    background: linear-gradient(135deg, rgba(214,136,74,0.28), rgba(214,136,74,0.05));
    border-color: rgba(238, 165, 95, 0.35);
    color: #eea55f;
  }
  .ins-name { font-size: 12px; font-weight: 600; letter-spacing: 0.01em; }

  .card-glow {
    position: absolute; inset: -50% 25% auto 25%;
    height: 60%;
    background: radial-gradient(50% 100% at 50% 0%, rgba(74,184,255,0.35), transparent 70%);
    opacity: 0; transition: opacity 0.25s ease;
    pointer-events: none;
  }
  .ins-card.vase .card-glow {
    background: radial-gradient(50% 100% at 50% 0%, rgba(238,165,95,0.35), transparent 70%);
  }
  .ins-card:hover .card-glow { opacity: 0.8; }

  .error {
    display: flex; align-items: center; gap: 8px;
    background: rgba(208, 74, 58, 0.12); color: #ffc0b8;
    border: 1px solid rgba(208, 74, 58, 0.32);
    padding: 9px 11px; border-radius: 9px;
    font-size: 12px; margin: 0; line-height: 1.4;
  }
</style>
